import _ from 'lodash';
import StatementsPreferencesEntity from '../entities/StatementsPreferencesEntity';
import AccountsStore from '../stores/AccountsStore';

class StatementsPreferencesParser {
  getRequestPacketForSetPreferences(requestData) {
    const requestPacket = {
      accounts: [],
    };
    _.map(requestData, (data) => {
      const account = {
        id: data.accountId,
        paper_statement_opt_out: data.optOutFlag,
      };
      requestPacket.accounts.push(account);
    });
    return requestPacket;
  }
  statementPreferencesParser(response) {
    const preferences = [];
    _.map(response.accounts, (prefs, index) => {
      const stmtPrefEntity = new StatementsPreferencesEntity();
      stmtPrefEntity.accountId = prefs.id;
      stmtPrefEntity.optOutFlag = prefs.paper_statement_opt_out;
      stmtPrefEntity.visibility = prefs.visibility;
      // stmtPrefEntity.display_order = prefs.display_order; TODO once service updated
      const accountDetails = AccountsStore.getAccountDetail(
        stmtPrefEntity.accountId
      );
      stmtPrefEntity.accountName =
        prefs.display_name === null || _.isEmpty(prefs.display_name)
          ? accountDetails.displayName
          : prefs.display_name;
      stmtPrefEntity.sortCode = accountDetails.sortCode;
      stmtPrefEntity.accountNumber = accountDetails.accountNumber;
      stmtPrefEntity.availableBalance = accountDetails.balances[0].amount;
      stmtPrefEntity.display_order = accountDetails.display_order;

      preferences.push(stmtPrefEntity);
    });
    return _.sortBy(preferences, ['display_order']);
  }
}

export default new StatementsPreferencesParser();
